import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { SearchService } from "src/app/services/search.service";


@Component({
    selector: 'app-results-message',
    templateUrl: './results-message.component.html',
    styleUrls: ['./results-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResultsMessageComponent {
    data: any;
    constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig, public searchService: SearchService) {
        this.data = config.data;
        this.ref.onClose.subscribe(() => {
            this.searchService.updateIsResultsPopupOpen(false);
        });
    }
}